import { apiQueryAdapter } from "../apiQueryAdapter";
import { PageResponseModel } from "../common/models";
import { CallTranscript } from "./models";

class CustomerServiceService {
  private static instance: CustomerServiceService;

  private constructor() {}

  static getInstance(): CustomerServiceService {
    if (!CustomerServiceService.instance) {
      CustomerServiceService.instance = new CustomerServiceService();
    }
    return CustomerServiceService.instance;
  }

  public getCallTranscripts = async (
    phoneNumber: string,
    page: number,
    size: number,
    trackingNumber?: string
  ): Promise<PageResponseModel<CallTranscript>> => {
    const params: Record<string, any> = {
      page: page,
      pageSize: size
    };
    
    if (phoneNumber) {
      params.phoneNumber = phoneNumber;
    }

    if (trackingNumber) {
      params.trackingNumber = trackingNumber;
    }

    const response = await apiQueryAdapter.query(
      "/ai-tools/call-transcripts/recent",
      "GET",
      { params }
    );
    
    return {
      content: response.data.content || [],
      pageable: {
        pageNumber: response.data.pageable?.pageNumber || 0
      },
      last: response.data.last || false
    };
  };
}

export default CustomerServiceService;

